export const CLOSED = `download_register_form_pop_closed`

export const GUIDE_IMAGE_BG_KEY = 'GUIDE_IMAGE_BG_KEY'